import { render } from "./ValidatorDetail.vue?vue&type=template&id=22cafd28&scoped=true"
import script from "./ValidatorDetail.vue?vue&type=script&lang=js"
export * from "./ValidatorDetail.vue?vue&type=script&lang=js"

import "./ValidatorDetail.vue?vue&type=style&index=0&id=22cafd28&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cafd28"],['__file',"resources/js/components/ValidatorDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22cafd28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22cafd28', __exports__)) {
    api.reload('22cafd28', __exports__)
  }
  
  module.hot.accept("./ValidatorDetail.vue?vue&type=template&id=22cafd28&scoped=true", () => {
    api.rerender('22cafd28', render)
  })

}


export default __exports__